/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { v4 } from 'uuid'
import ReCAPTCHA from 'react-google-recaptcha'

// Images
import arrowRightWhite from 'img/arrow-right-white.svg'

// Components
import { _each } from 'lodash'
import Select from 'react-select'
import Content from './shared/Content'
import Loading from './shared/Loading'
import ButtonDefault from './elements/ButtonDefault'

// Third Party

const StyledForm = styled.form`
  position: relative;
`

const ConfirmationMessage = styled(Content)`
  font-size: ${(props) => props.theme.font.size.xm};
  font-family: ${(props) => props.theme.font.family.secondaryAlt};
  text-align: center;
`

const Label = styled.label`
  display: block;
`

const Mandatory = styled.span`
  font-size: ${(props) => props.theme.font.size.xm};
  color: ${(props) => props.theme.color.contrast};
  margin-left: 5px;
`

const GravityForm = ({ id }) => {
  const recaptchaSiteKey = '6Le8VScsAAAAAJWDV0JItt4d384laRP_LIf_VOtM'
  const recaptchaRef = useRef(null)
  const [recaptchaError, setRecaptchaError] = useState(false)

  const {
    allGfForm: { edges: gravityData },
  } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(
    ({ node }) => node.formId === id
  )[0]

  const [fields, setFields] = useState({})
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')
  const isBrowser = typeof window !== 'undefined'
  const shouldUseRecaptcha = Boolean(recaptchaSiteKey)

  useEffect(() => {
    const tempForm = form

    // add submit button as a field
    if (
      tempForm.formFields.filter((item) => item.type === 'submit').length === 0
    ) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: 'submit',
          text: tempForm.button.text,
        },
      ]
    }

    setForm({
      ...form,
      ...tempForm,
    })
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    if (shouldUseRecaptcha && !fields['g-recaptcha-response']) {
      setRecaptchaError(true)
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')

        setMessage(response.confirmation_message)
      } else {
        setStatus('error')
        console.log(response)
      }
    } catch (error) {
      setStatus('error')
      console.error(error)
    }
  }

  function removeRecaptchaResponse(prevFields) {
    const updatedFields = { ...prevFields }
    delete updatedFields['g-recaptcha-response']
    return updatedFields
  }

  function handleRecaptchaChange(token) {
    setRecaptchaError(false)

    if (!token) {
      setFields((prevFields) => removeRecaptchaResponse(prevFields))
      return
    }

    setFields((prevFields) => ({
      ...prevFields,
      'g-recaptcha-response': token,
    }))
  }

  function handleRecaptchaExpired() {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset()
    }
    setFields((prevFields) => removeRecaptchaResponse(prevFields))
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === 'checkbox') {
        value = event.target.checked ? event.target.value : ''
      }

      setFields({
        ...fields,
        [event.target.name]: value,
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value,
      })
    }
  }

  if (status === 'done') {
    return <ConfirmationMessage content={message} />
  }

  if (form.formFields) {
    const renderRecaptcha = () => {
      if (!isBrowser || !shouldUseRecaptcha) {
        return null
      }

      return (
        <RecaptchaWrapper>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={recaptchaSiteKey}
            onChange={handleRecaptchaChange}
            onExpired={handleRecaptchaExpired}
          />
          {recaptchaError && (
            <RecaptchaError>Bevestig alstublieft dat u geen robot bent.</RecaptchaError>
          )}
        </RecaptchaWrapper>
      )
    }

    return (
      <StyledForm
        id={`form_${gfForm.formId}`}
        method="post"
        onSubmit={handleOnSubmit}
      >
        {status === 'processing' && <Loading />}
        {form.formFields &&
          form.formFields.map((field, key) => {
            if (Array.isArray(field)) {
              return (
                <div key={key}>
                  {field.map((item, index) => (
                    <FormField
                      key={index}
                      field={item}
                      fields={fields}
                      onChange={handleFieldChange}
                      renderRecaptcha={renderRecaptcha}
                    />
                  ))}
                </div>
              )
            }

            return (
              <div key={key}>
                <FormField
                  field={field}
                  fields={fields}
                  onChange={handleFieldChange}
                  renderRecaptcha={renderRecaptcha}
                />
              </div>
            )
          })}
      </StyledForm>
    )
  }

  console.error('No gravity forms found with id', id)
  return false
}

const StyledTextField = styled.div`
  width: 100%;

  ${Label} {
    font-size: ${(props) => props.theme.font.size.sm};
    color: ${(props) => props.theme.color.text.lightgrey};
  }

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
    height: 42px;

    padding-left: 10px;
    padding-right: 10px;
    font-family: ${(props) => props.theme.font.family.main};
  }
`

const TextField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <StyledTextField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="text"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextField>
)

const StyledEmailField = styled.div`
  width: 100%;

  ${Label} {
    font-size: ${(props) => props.theme.font.size.sm};
    color: ${(props) => props.theme.color.text.lightgrey};
  }

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
    height: 42px;

    padding-left: 10px;
    padding-right: 10px;
    font-family: ${(props) => props.theme.font.family.main};
  }
`

const EmailField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <StyledEmailField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledEmailField>
)

const StyledPhoneField = styled.div`
  width: 100%;

  ${Label} {
    font-size: ${(props) => props.theme.font.size.sm};
    color: ${(props) => props.theme.color.text.lightgrey};
  }

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
    height: 42px;

    padding-left: 10px;
    padding-right: 10px;
    font-family: ${(props) => props.theme.font.family.main};
  }
`

const PhoneField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <StyledPhoneField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <input
      value={value}
      onChange={onChange}
      type="tel"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledPhoneField>
)

const StyledTextAreaField = styled.div`
  width: 100%;

  ${Label} {
    font-size: ${(props) => props.theme.font.size.sm};
    color: ${(props) => props.theme.color.text.lightgrey};
  }

  textarea {
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.border};
    min-height: 150px;

    padding-left: 10px;
    padding-right: 10px;
    font-family: ${(props) => props.theme.font.family.main};
  }
`

const TextAreaField = ({
  value,
  onChange,
  field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass },
}) => (
  <StyledTextAreaField className="form-group">
    {labelPlacement !== 'hidden_label' && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && <Mandatory>*</Mandatory>}
      </Label>
    )}
    <textarea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextAreaField>
)

const CheckboxField = ({
  value,
  onChange,
  field: { id, type, cssClass, choices },
}) => {
  const list = JSON.parse(choices)

  return (
    <div className="form-group">
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <input
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label
            htmlFor={`input_${id}_${key + 1}`}
            className="checkbox-content"
          >
            {checkbox.text}
          </label>
        </div>
      ))}
    </div>
  )
}

const StyledSelect = styled.div``

// Select or Dropdown
const SelectField = ({ field, onChange, value }) => {
  // Populate a options array
  const options = []

  const choices = JSON.parse(field.choices)

  choices.forEach((choice) => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`,
    })
  })

  // Custom Select component
  const MySelect = (props) => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <StyledSelect className="mb-4">
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
      />
    </StyledSelect>
  )
}

const StyledButtonDefault = styled(ButtonDefault)`
  transition: transform 0.25s;
`

const StyledSubmitButton = styled.div`
  &:hover {
    ${StyledButtonDefault} {
      transform: scale(1.05);
    }
  }
`

const RecaptchaWrapper = styled.div`
  margin: 20px 0;
`

const RecaptchaError = styled.p`
  margin-top: 10px;
  color: ${(props) => props.theme.color.contrast};
  font-size: ${(props) => props.theme.font.size.sm};
`

const SubmitButton = ({ field }) => (
  <StyledSubmitButton className="d-flex justify-content-end">
    <StyledButtonDefault isCustom>
      <button type="submit">
        <img className="mr-2" src={arrowRightWhite} alt="" />
        <p className="mb-0 font-family-secondary-alt">{field.text}</p>
      </button>
    </StyledButtonDefault>
  </StyledSubmitButton>
)

const FileField = ({
  value,
  onChange,
  field: { id, type, label, allowedExtensions, cssClass, placeholder },
}) => {
  function handleChange(file) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file,
      },
    })
  }

  function handleFileUpload(e) {
    const {
      e: {
        target: { files },
      },
    } = e

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault()

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile())
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i])
      }
    }
  }

  return (
    <div
      className="form-upload"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <Label htmlFor={`input_${id}`}>{value ? value.name : <>{label}</>}</Label>
      <input
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ''}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </div>
  )
}

export const FormField = ({ field, fields, onChange, renderRecaptcha }) => (
  <>
    {field.type === 'text' && (
      <TextField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'email' && (
      <EmailField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'phone' && (
      <PhoneField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'textarea' && (
      <TextAreaField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'checkbox' && (
      <CheckboxField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'select' && (
      <SelectField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'fileupload' && (
      <FileField
        onChange={onChange}
        value={fields[`input_${field.id}`]}
        field={field}
      />
    )}
    {field.type === 'submit' && (
      <>
        {renderRecaptcha && renderRecaptcha()}
        <SubmitButton field={field} />
      </>
    )}
  </>
)

export default GravityForm
